module.exports = __webpack_public_path__ + "static/media/id.248594b1.svg";